import cookie from "react-cookie";
import { isEmpty } from "ramda";
import api from "api/flexapi";
import { isMobileWebView } from "cxa-utils";
import { RouteMap } from "components/common/navigation/routeMap";
import { sessionTokenId as SESSION_TOKEN_ID, saveSession, setCurrentUser } from "./loginActions";
import { showToast } from "./toastActions";

export const REQUEST_UPGRADE_USER_SESSION = "REQUEST_UPGRADE_USER_SESSION";
export const SUCCESS_UPGRADE_USER_SESSION = "SUCCESS_UPGRADE_USER_SESSION";
export const FAILURE_UPGRADE_USER_SESSION = "FAILURE_UPGRADE_USER_SESSION";

/**
 * Upgrade user session
 * @param  {string}   nonce
 * @return {Function}
 */
export function upgradeUserSession(nonce = "") {
  const isDev = process.env.NODE_ENV === "development";

  if (!isEmpty(nonce)) {
    try {
      const { userAgent } = window.navigator;

      if (isMobileWebView(userAgent)) {
        cookie.save(SESSION_TOKEN_ID, nonce, { path: "/" });
      } else if (isDev) {
        cookie.save("cxa-session", nonce, { path: "/" });
      }
    } catch (e) {
      throw new Error("cannot save nonce");
    }
  }

  return dispatch => {
    dispatch({ type: REQUEST_UPGRADE_USER_SESSION });

    const { userAgent } = window.navigator;
    const data = {
      EnforceRoleSelection: !isMobileWebView(userAgent),
    };

    return new Promise((resolve, reject) => {
      api
        .upgradeUserSession(data)
        .then(response => {
          const { body } = response || {};

          if (isEmpty(body)) {
            throw new Error("No response from upgrade session API");
          }

          dispatch(saveSession(body));

          body.message && dispatch(showToast({ message: response.body.message }));

          const { pendingAuthActions = [] } = body;
          const hasPendingActions =
            pendingAuthActions.includes("GrantConsent") ||
            pendingAuthActions.includes("ResetExpiredPassword");

          if (body.hrAdmin && !body.employee && !hasPendingActions) {
            // eslint-disable-next-line xss/no-location-href-assign
            const toastMessage = (response.body.message && `&toast=${response.body.message}`) || "";
            location.href = `${RouteMap.ReportsMain}/?token=${response.body.token}${toastMessage}`;
            return;
          }

          dispatch(setCurrentUser(body));
          dispatch({ type: SUCCESS_UPGRADE_USER_SESSION });
          resolve(body);
        })
        .catch(err => {
          // NOTE: it should not be happened unless backend has issue
          dispatch({
            type: FAILURE_UPGRADE_USER_SESSION,
            payload: err,
          });
        });
    });
  };
}



// WEBPACK FOOTER //
// ./actions/ssoActions.js